import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';

import Menu from '../../components/Menu';
import Container from '../../containers/Container';
import { ReactComponent as LogoSvg } from '../../res/logo_blanc.svg';
import styles from './styles';

class HomeFirst extends React.Component {
  constructor(props) {
    super(props);
    this.onClickLogo = this.onClickLogo.bind(this);
  }

  onClickLogo() {
    const { data } = this.props;
    window.open(data['site-ush'], '_blank');
  }

  render() {
    const { classes, data } = this.props;
    const { first: block } = data.home;
    return (
      <>
        <Container id="home-first" className={classes.container} position="fixed" zIndex={0}>
          <Menu data={data} route="home" />
          <LogoSvg className={classes.logo} onClick={this.onClickLogo} />
          <svg width="63" height="55" viewBox="0 0 63 55" className={classes.polygone12}>
            <path d="M47.25,0,63,27.5,47.25,55H15.75L0,27.5,15.75,0Z" />
          </svg>
          <svg width="321.08" height="303.068" viewBox="0 0 321.08 303.068" className={classes.polygone31}>
            <path
              d="M191.25,0,255,110.5,191.25,221H63.75L0,110.5,63.75,0Z"
              transform="translate(0 99.636) rotate(-23)"
            />
          </svg>
          <svg width="72.337" height="66.01" viewBox="0 0 72.337 66.01" className={classes.polygone32}>
            <path d="M47.25,0,63,27.5,47.25,55H15.75L0,27.5,15.75,0Z" transform="translate(0 12.021) rotate(-11)" />
          </svg>
          <svg width="110.121" height="102.154" viewBox="0 0 110.121 102.154" className={classes.polygone9}>
            <path d="M68.25,0,91,39.5,68.25,79H22.75L0,39.5,22.75,0Z" transform="translate(23.097) rotate(17)" />
          </svg>
          <div className={classes.firstRow}>
            <Typography variant="h1" component="h1" className={classes.h1}>
              {parse(block.title)}
            </Typography>
            <Typography variant="h2">{parse(block.subtitle)}</Typography>
          </div>
          <div className={classes.secondRow}>
            <Typography variant="subtitle1">{parse(block.description)}</Typography>
          </div>
        </Container>
        <Container className={classes.overContainer} zIndex={-1}>
          <svg width="305.586" height="274.947" viewBox="0 0 305.586 274.947" className={classes.polygone30}>
            <path d="M206.25,0,275,119.5,206.25,239H68.75L0,119.5,68.75,0Z" transform="translate(33.262) rotate(8)" />
          </svg>
          <svg width="111.762" height="104.323" viewBox="0 0 111.762 104.323" className={classes.polygone33}>
            <path d="M68.25,0,91,39.5,68.25,79H22.75L0,39.5,22.75,0Z" transform="translate(0 29.627) rotate(-19)" />
          </svg>
        </Container>
      </>
    );
  }
}

HomeFirst.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeFirst);
